import { EXPAND_FIELD_PREFIX } from '@constants'

export const getDropdownExpands = (objectValue: string) => {
  const pathParts = objectValue.split('.').filter(Boolean)

  if (pathParts.length < 2) {
    return []
  }

  const refPathParts = pathParts.slice(0, -1)

  return refPathParts.map((_, index) => {
    const sourcePath = refPathParts.slice(0, index + 1).join('.')
    const expandPath = refPathParts
      .slice(0, index + 1)
      .map(pathPart => `${EXPAND_FIELD_PREFIX}${pathPart}`)
      .join('.')

    return `${sourcePath}:${expandPath}`
  })
}